import { SvgBackArrow } from 'assets/svg';
import s from './ProgressBar.module.css';
import cn from 'classnames';

const ProgressBar = ({ step, handlePrevStep }) => {
	return (
		<div className={cn(s.root)}>
			<SvgBackArrow className={s.backArrow} onClick={handlePrevStep} />
			<div className={cn(s.progressItem, step > 0 && s.active)}></div>
			<div className={cn(s.progressItem, step > 1 && s.active)}></div>
			<div className={cn(s.progressItem, step > 2 && s.active)}></div>
			<div className={cn(s.progressItem, step > 3 && s.active)}></div>
			<div className={cn(s.progressItem, step > 4 && s.active)}></div>
		</div>
	);
};

export default ProgressBar;
